import Button from '@jetbrains/ring-ui-built/components/button/button'
import {Directions} from '@jetbrains/ring-ui-built/components/popup/popup.consts'
import Tooltip from '@jetbrains/ring-ui-built/components/tooltip/tooltip'
import {IconButton} from '@jetbrains/teamcity-ui/dist/components'
import {useCallback} from 'react'

import {dialog} from '../../../slices'
import type {ProjectId} from '../../../types'
import {DialogType, ROOT_PROJECT_ID} from '../../../types'
import {useHint} from '../../packages/Hints/Hints.hooks'
import {HINT_CATEGORY, stringifyHintId, toHintId} from '../../packages/Hints/Hints.types'
import type {Hint} from '../../packages/Hints/Hints.types'
import {useSequenceLoaderReadyHandler} from '../SequenceLoader/SequenceLoader.hooks'
import type {SeqProps} from '../SequenceLoader/SequenceLoader.types'

import styles from './EditProjectSidebar.module.css'

import {useAppDispatch} from 'src/hooks/react-redux'

const configureSidebarHint: Hint = {
  id: toHintId('configure-project-sidebar'),
  name: 'Configure sidebar',
  text: 'Reorder your favorite projects.',
  category: HINT_CATEGORY.sidebar,
  className: styles.configureSidebarHint,
  directions: [Directions.BOTTOM_RIGHT],
}

type OwnProps = SeqProps & {
  button?: boolean | null | undefined
  projectId?: ProjectId | undefined
}

export const openEditDialog = (projectId: ProjectId = ROOT_PROJECT_ID) =>
  dialog.actions.open(projectId, DialogType.EDIT_SIDEBAR)

export default function EditProjectSidebar({button, projectId}: OwnProps) {
  useSequenceLoaderReadyHandler(true)
  useHint(configureSidebarHint)
  const dispatch = useAppDispatch()
  const openDialog = useCallback(() => dispatch(openEditDialog(projectId)), [dispatch, projectId])
  return button === true ? (
    <Button
      data-hint-container-id={stringifyHintId(configureSidebarHint.id)}
      className={styles.button}
      onClick={openDialog}
      aria-label={'Configure favorites'}
    >
      {`Configure favorites...`}
    </Button>
  ) : (
    <Tooltip title={'Edit favorites'}>
      <IconButton
        data-hint-container-id={stringifyHintId(configureSidebarHint.id)}
        icon="pencil"
        className={styles.iconButton}
        title={''}
        onClick={openDialog}
        aria-label={'Edit favorites'}
      />
    </Tooltip>
  )
}
